import React from "react";
import { CircularProgress as MUICircularProgress, CircularProgressProps } from "@mui/material";

const CircularProgress: React.FC<CircularProgressProps> = (props) => {
    return <MUICircularProgress {...props} />;
};

export default CircularProgress;
